module.exports = __webpack_public_path__ + "static/media/3.606947f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assests/img/seenapse/others/3.jpg
// module id = 690
// module chunks = 0